export default __webpack_public_path__ + "static/media/roundedRect.bae231aa.svg";